import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types'
import { useSelector } from "react-redux";
import { Modal, Row, Col, Image, Button } from 'react-bootstrap'
import { ReusableOnboardingButton } from '../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton'


import { InputBox } from "../inputReusableComponent/InputBox";
import { useFormik } from "formik";
import { ReactCropperImageUpload } from "../imageUploadReusableComponent/ReactCropperImageUpload";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../imageUploadReusableComponent/MultipleImageUploadComponent";
import Alert from "react-s-alert";
import axios from "axios";
import { serverApi } from "../../../config/Keys";

import * as yup from "yup";
import isEmpty from "../../../store/validation/is-Empty";
import { Gender } from "../../../enums/DropDownDataTable";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const validationSchema = yup.object({
    full_name: yup
        .string()
        .required("Name is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
    age: yup
        .number()
        .positive()
        .integer()
        .required("Age is required")
        .min(18, "Please enter valid age")
        .max(100),
    gender: yup
        .string()
        .oneOf(["MALE", "FEMALE", "OTHER"])
        .required('Gender is required'),
    mobile_number: yup.string().required("Mobile number is required")
        .matches(phoneRegExp, 'Phone number is not valid')
        .min(10, "Please enter valid Phone Number")
        .max(10, "Please enter valid Phone Number"),
    profile_image: yup.array().min(1, "Please upload profile picture").required(" Profile picture is required"),
    driving_license: yup.array().min(1, "Please upload driving license").required("Please upload driving license"),


});

const gender = ["", "MALE", "FEMALE", "OTHER"];

const AddOrEditDeliveryPersonModal = props => {
    const { showAddEdit, handleCloseAdd, actionData, onValueRedirect } = props;
    const inputRef = useRef(null)
    const inputRefDoc = useRef(null)

    const [state, setState] = useState({
        restaurant_video: [],
        video_url: "",
        progress: 0,
        actionButton: false,
    });
    const [disabled, setDisabled] = useState(false)


    const vendor = useSelector((state) => {
        return !isEmpty(state.auth) ? state.auth.user?.VendorUser : {};
    });

    const restaurant = useSelector((state) => {
        return !isEmpty(state.onboarding)
            ? state.onboarding?.restaurantDetails
            : {};
    });

    useEffect(() => {
        if (!isEmpty(actionData)) {
            formik.setValues({
                ...formik.values,
                full_name: actionData?.full_name,
                age: actionData?.age,
                gender: actionData?.gender,
                mobile_number: actionData?.mobile_number,
                driving_license: [actionData?.driving_license],
                profile_image: [actionData?.profile_image],
            })
        }
    }, [actionData])



    const formik = useFormik({
        initialValues: {
            full_name: "",
            age: "",
            gender: "",
            mobile_number: "",
            country_code: "+91",
            driving_license: [],
            profile_image: [],
            docs: [],
        },
        validationSchema,

        onSubmit: (values) => {
            let formData = {
                country_code: values.country_code,
                full_name: values.full_name,
                age: values.age,
                gender: values.gender,
                mobile_number: values.mobile_number.toString(),
                driving_license: values.driving_license?.[0] || "",
                profile_image: values.profile_image?.[0] || "",
            };
            onValueRedirect(formData);
        },
    });
    const onClickSave = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    };
    const handleCloseAddIssue = () => {
        formik.resetForm();
        handleCloseAdd();
    };
    /*************************************
   * @DESC IMAGE UPLOAD 
   ************************************/

    const bankDocMultipleRemove = (indexId) => {
        let allImages = formik.values.profile_image.filter((item, index) => {
            return index !== indexId;
        });
        formik.setFieldValue("profile_image", allImages);
    };
    const licenseDocs = (indexId) => {
        let drivingLicenseDocs = formik.values.driving_license.filter((item, index) => {
            return index !== indexId;
        });
        formik.setFieldValue("driving_license", drivingLicenseDocs);
    };
    
    const onCompleteUpload = (files, thumbnails) => {
        formik.setFieldValue("profile_image", [...files]);
        formik.setFieldValue("photos", [ ...files]);
        formik.setFieldValue("photoThumbnails", [...thumbnails]);
    };
    
    /*************************************
   * @DESC UPLOAD DOCUMENTS
   ************************************/
    const [combined, setCombined] = React.useState("");
    const [restaurant_pictures_new, setResPicNew] = React.useState([]);
    const onCompleteUploadMultipleCrop = (e, file) => {
        let oldData = formik.values.driving_license;
        let newData = e;
        let mergedData = oldData.concat(newData);
        formik.setFieldValue("driving_license", mergedData);
        cancelFiles(file);
    };
    const cancelFiles = (file) => {
        let restaurant_pictures_temp = restaurant_pictures_new;
        let newToUpload = restaurant_pictures_temp.filter((item, index) => {
            return item.name !== file.name;
        });
        setResPicNew(newToUpload)
    }
    const bankUploadMultipleFiles = (e) => {
        const vendor_id = vendor?._id;
        const restaurant_name = restaurant?.restaurant_name
            .split(" ")
            .join("");
        const combined = vendor_id + "_" + restaurant_name;
        const data = new FormData();
        let flag = false;
        var newUploaded = [];
        var docs = false;
        for (let i = 0; i < e.target.files?.length; i++) {
            let allPicures = formik.values.docs;
            allPicures.some((phone) => {
                if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
                    flag = true;
                }
            });
            if (!flag) {
                if (e.target.files[i].type === "application/pdf") {
                    docs = true;
                    data.append("files", e.target.files[i]);
                } else {
                    newUploaded.push(e.target.files[i]);
                }
            }
        }
        if (!flag) {
            setResPicNew(newUploaded);
            setCombined(combined);
            if (docs) {
                axios
                    .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
                    .then((res) => {
                        let oldData = formik.values.docs;
                        let newData = res.data;
                        let mergedData = oldData.concat(newData);
                        formik.setFieldValue("driving_license", mergedData);
                        Alert.success(`<h4>Driving License Uploaded Successfully</h4>`, {
                            position: "top-right",
                            effect: "bouncyflip",
                            beep: true,
                            html: true,
                            timeout: 3000,
                            offset: 35,
                        });
                    })
                    .catch((err) => {
                        Alert.error(`<h4>${err}</h4>`, {
                            position: "top-right",
                            effect: "bouncyflip",
                            beep: true,
                            html: true,
                            timeout: 3000,
                            offset: 35,
                        });
                    });
            }
        } else {
            Alert.error(`<h4>Can not upload the same image</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
            });
        }
        e.target.value = "";
    };
    return (
        <Modal
            backdrop="static"
            keyboard={false}
            centered
            size="md"
            show={showAddEdit} onHide={handleCloseAdd}>
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
                <Modal.Title className="f20-500">{actionData !== null ? "Edit" : "Add"} Delivery Person</Modal.Title>
            </Modal.Header>
            <Col >
                <div className="event-offer-image mt-3">
                    <ReactCropperImageUpload
                        title="Upload Profile Picture*"
                        smallTitle=""
                        onComplete={onCompleteUpload}
                        combined={
                            (vendor?._id || "") +
                            "_" +
                            (restaurant?.restaurant_name?.split(" ").join("") || "")
                        }
                        value={formik.values.profile_image}
                        removeImage={bankDocMultipleRemove}
                        maxImageSize={500000}
                        singleUpload={true}
                    />
                    <div className="font_12_r  mb-4 d-flex">
                        Min 1 pics | Max size 500kb/pic
                    </div>
                </div>{" "}
                {formik.errors.profile_image && formik.touched.profile_image ? (
                    <div className="mb-3 pho_14_regular text-danger">
                        {formik.errors.profile_image}
                    </div>
                ) : (
                    <div className="mb-3"> </div>
                )}
            </Col>
            <div className="col-12 mt-3 pl-3 pr-3">
                <InputBox name="full_name" inputType="text" labelText="Full Name" value={formik.values.full_name} onChange={formik.handleChange} />
                {formik.errors.full_name && formik.touched.full_name ? (
                    <div className="pho_14_regular text-danger">
                        {formik.errors.full_name}
                    </div>
                ) : null}
            </div>
            <div className="row pl-3 pr-3">
                <div className="col-6">
                    <FormControl variant="outlined" className={"w-100"}  >
                        <InputLabel htmlFor="outlined-Category">
                            Gender
                        </InputLabel>
                        <Select
                            name="gender"
                            id="gender"
                            label="Gender"
                            onChange={formik.handleChange}
                            value={formik.values.gender}
                            onBlur={formik.handleBlur}
                            isInvalid={
                                formik.errors.gender &&
                                formik.touched.gender
                            }
                            IconComponent={KeyboardArrowDownIcon}
                            disabled={disabled}
                        >
                            <MenuItem value="">Select Gender</MenuItem>
                            <MenuItem value="MALE">Male</MenuItem>
                            <MenuItem value="FEMALE">Female</MenuItem>
                            <MenuItem value="OTHER">Other</MenuItem>

                        </Select>
                    </FormControl>
                    {formik.errors.gender && formik.touched.gender ? (
                        <div className="pho_14_regular text-danger mt-3">
                            {formik.errors.gender}
                        </div>
                    ) : null}
                </div>
                <div className="col-6">
                    <InputBox name="age" inputType="number" labelText="Age" value={formik.values.age} onChange={formik.handleChange} />
                    {formik.errors.age && formik.touched.age ? (
                        <div className="pho_14_regular text-danger">
                            {formik.errors.age}
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="col-12 pl-3 pr-3">
                <InputBox name="mobile_number" inputType="number" value={formik.values.mobile_number} labelText="Phone Number" onChange={formik.handleChange} helpTextDisplay={true} helperTextBottom="must be registered with whatsapp*" />
                {formik.errors.mobile_number && formik.touched.mobile_number ? (
                    <div className="pho_14_regular text-danger">
                        {formik.errors.mobile_number}
                    </div>
                ) : null}
            </div>
            <div className="col-12 mt-3 pl-3 pr-3">
                <SimpleReactLightbox>
                    <MultipleImageUploadComponent
                        title="Upload Driving License"
                        smallTitle="(Upload supporting documents such as a pdf,jpg,png"
                        onChange={bankUploadMultipleFiles}
                        stateValue={formik.values.driving_license}
                        newUploaded={
                            restaurant_pictures_new
                                ? restaurant_pictures_new
                                : []
                        }
                        combined={combined}
                        onCompleteUploadMultipleCrop={
                            onCompleteUploadMultipleCrop
                        }
                        cancelFiles={cancelFiles}
                        removeImage={licenseDocs}
                        accept=".pdf,image/jpg,image/png"
                        extraClass="fullWidth-Image-upload"
                    />
                </SimpleReactLightbox>
                {formik.errors.driving_license && formik.touched.driving_license ? (
                    <div className="pho_14_regular text-danger">
                        {formik.errors.driving_license}
                    </div>
                ) : (<div className="mb-3"> </div>)}
            </div>
            <div className="col-10 m-3 p-2 d-flex">
                <ReusableOnboardingButton
                    buttonTitle="Cancel Button"
                    buttonClass={"col-5 btn-sm btn btn-outline-secondary mr-3"}
                    buttonText="Cancel"
                    onClick={handleCloseAddIssue}
                    buttonType="button"
                />
                <ReusableOnboardingButton
                    buttonTitle="Confirm Button"
                    buttonClass="btn-sm col-8 btn btn-danger btn-block"
                    buttonText="Confirm"
                    onClick={(e) => onClickSave(e)}
                    buttonType="button"
                />
            </div>
        </Modal>
    )
}

AddOrEditDeliveryPersonModal.propTypes = {}

export default AddOrEditDeliveryPersonModal